<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <h1>e-business card</h1>
        <p class="my-3">&nbsp;</p>
        <div class="alert bg-light">
          <p>
            • e-business card will be dispalyed on exhibitor's company booth,
            and exhibitor can have immidate communication through text and video
            with buyers during the exhibition.
          </p>
          <p>
            • The information of e-business card is editable in the database of
            Chan Chao membership.
          </p>
          <p>
            • All the communication records will also be removed from the system
            when e-business cards were deleted.
          </p>
          <p>
            • e-business card delegates must complete the registration to Chan
            Chao membership prior. The system will not be able to produce
            e-business card to the delegate, and the delegate will not have the
            access to all functions.
          </p>
          <p>
            <span>
              The link to Chan Chao membership:
              <span style="color: rgb(102, 101, 101); font-size: 5px">
                https://www.chanchao.com.tw/accounts/en/signup
              </span>
            </span>
          </p>
        </div>
        <div class="cardType mt-3">
          <!-- 首次進入 -->

          <div class="col-sm-6 mb-2" v-if="firstEntry">
            <div
              class="card mt-3 d-flex justify-content-center align-items-center shadow pointer"
              data-toggle="modal"
              data-target="#AddCardModal"
              style="background-color: rgb(220, 221, 219)"
            >
              <i class="fas fa-plus-circle fa-4x text-secondary"></i>
              <p class="text-secondary mt-3" style="font-size: 18px">
                Add e-business Card
              </p>
            </div>
          </div>

          <div class="row">
            <div
              class="col-sm-6 mb-2 justify-content-end"
              v-for="item in CardInfo"
            >
              <div v-if="item.Verified == 1">
                <div class="card mt-3 bg-white shadow text-sm-left text-center">
                  <div class="card-header">
                    <p class="my-3">&nbsp;</p>
                  </div>
                  <div class="card-body">
                    <div class="row m-1 justify-content-between">
                      <div
                        class="delIcon text-danger pointer"
                        @click.prevent="DelTwEnCard(item.Email)"
                      >
                        <i
                          class="fas fa-minus-circle"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Delete"
                        ></i>
                      </div>
                      <div class="col-md-4">
                        <div class="mt-3">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.Logo}`"
                            width="100px"
                            alt=""
                          />
                        </div>
                      </div>
                      <div class="col-md-8 mt-2">
                        <h3 class="mb-3">{{ item.Company }}</h3>
                        <p>{{ item.Dept }}</p>
                        <h3 class="mb-3 font-weight-bold">{{ item.name }}</h3>
                        <p v-if="item.Address">
                          <i
                            class="fas fa-map-marker-alt mr-1 mb-1"
                            style="color: #6b6766"
                          ></i>
                          {{ item.Address }}
                        </p>
                        <p v-if="item.Tel">
                          <i
                            class="fas fa-phone-square-alt mr-1 mb-1"
                            style="color: #6b6766"
                          ></i>
                          {{ item.Tel }} #{{ item.Ext }}
                        </p>
                        <p v-if="item.Email">
                          <i
                            class="fas fa-envelope-square mr-1"
                            style="color: #6b6766"
                          ></i>
                          {{ item.Email }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item.Verified == 0">
                <div
                  class="card mt-3 d-flex justify-content-center align-items-center shadow p-2"
                  style="background-color: rgb(220, 221, 219)"
                >
                  <div
                    class="delIcon text-danger pointer"
                    @click.prevent="DelTwEnCard(item.Email)"
                  >
                    <i
                      class="fas fa-minus-circle"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Delete"
                    ></i>
                  </div>
                  <i
                    class="fas fa-exclamation-circle fa-4x"
                    style="color: rgb(206, 100, 96)"
                  ></i>
                  <div
                    style="font-size: 15px"
                    class="text-secondary text-center"
                  >
                    <p class="mt-3">
                      The email account <u>{{ item.Email }}</u> is not
                      activated.
                    </p>
                    <p>
                      Notification will be sent to the email account desginated,
                      and please follow the instruction to activate your
                      account.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 判定Vip層級及剩餘卡片數 -->
            <div
              class="col-sm-6 mb-2"
              v-if="!firstEntry && isVip && 2 > CardNum"
            >
              <div
                class="card mt-3 d-flex justify-content-center align-items-center shadow pointer BannerHover"
                data-toggle="modal"
                data-target="#AddCardModal"
                style="background-color: rgb(220, 221, 219)"
              >
                <i class="fas fa-plus-circle fa-4x text-secondary"></i>
                <p class="text-secondary mt-3" style="font-size: 18px">
                  Add e-business Card
                </p>
              </div>
            </div>
          </div>

          <!-- 新增卡片Modal -->
          <div
            class="modal fade"
            id="AddCardModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h3
                    class="modal-title font-weight-bold"
                    id="exampleModalLabel"
                  >
                    Add e-business card
                  </h3>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p>Please enter an account of Chan Chao membership.</p>
                  <form id="form1" @submit.prevent="TwEnAddStaffInfo">
                    <p class="formTitle mt-4">
                      Email <span class="red">*</span>
                    </p>
                    <input
                      type="email"
                      name="ClientEmail"
                      class="textStyle maxText"
                      maxlength="50"
                      required
                      v-model="staffMail"
                    />
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    data-bs-target="#myModal"
                  >
                    Back
                  </button>

                  <input
                    type="submit"
                    value="Send"
                    class="btn btn-primary"
                    @click.prevent="TwEnAddStaffInfo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      isVip: true,
      CSRF_Token: "",
      RegNo: "",
      staffMail: "",
      E_Lang: "en",
      CardInfo: [],
      CardNum: "",
      firstEntry: "",
    };
  },

  methods: {
    DelCard(Email) {
      const vm = this;
      if (confirm("請確認要刪除此電子名片嗎？")) {
        const info = {
          CSRF: vm.CSRF_Token,
          Email: Email,
        };
        const url = `/apiExhibitors/RemoveBoothstaff/${vm.RegNo}`;

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("您選擇的電子名片已刪除！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("系統忙碌，請稍後再試！");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("信箱錯誤！");
          } else if (response.data.Code == 254) {
            alert("電子名片移除未成功！");
          }
        });
      } else {
        return false;
      }
    },

    DelEnCard(Email) {
      const vm = this;
      if (confirm("Delete this e-business card？")) {
        const info = {
          CSRF: vm.CSRF_Token,
          Email: Email,
        };
        const url = `/apiExhibitors/RemoveBoothstaff/${vm.RegNo}`;

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("This e-business card is deleted. ");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("System is busy, please try again later.");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("Email Error！");
          } else if (response.data.Code == 254) {
            alert("Failed to remove this e-business card. ");
          }
        });
      } else {
        return false;
      }
    },

    DelTwEnCard(Email) {
      const vm = this;
      if (confirm("Delete this e-business card？")) {
        const info = {
          CSRF: vm.CSRF_Token,
          Email: Email,
        };
        const url = `/apiExhibitors/RemoveBoothstaff/${vm.RegNo}`;

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("This e-business card is deleted.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("System is busy, please try again later.");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("Email Error！");
          } else if (response.data.Code == 254) {
            alert("Failed to remove this e-business card. ");
          }
        });
      } else {
        return false;
      }
    },

    DelEnCnCard(Email) {
      const vm = this;
      if (confirm("請確認要刪除此電子名片嗎？")) {
        const info = {
          CSRF: vm.CSRF_Token,
          Email: Email,
        };
        const url = `/apiExhibitors/RemoveBoothstaff/${vm.RegNo}`;

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("您選擇的電子名片已刪除！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_zhtw_onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("系統忙碌，請稍後再試！");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("信箱錯誤！");
          } else if (response.data.Code == 254) {
            alert("電子名片移除未成功！");
          }
        });
      } else {
        return false;
      }
    },

    AddStaffInfo() {
      const vm = this;
      const url = "/apiExhibitors/Boothstaff/";

      const info = {
        RegNo: vm.RegNo,
        Email: vm.staffMail,
        CSRF: vm.CSRF_Token,
        Lang: vm.E_Lang,
      };

      // console.log(info)

      if (!vm.staffMail) {
        alert("輸入欄位不完整，請重新檢查！");
      } else {
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("電子名片新增成功！");
            $("#AddCardModal").modal("hide");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("系統忙碌，請稍後再試！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 254) {
            alert("您輸入的 Email 已被使用，請重新輸入！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 253) {
            alert("新增失敗，已超過電子名片額度上限！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 255) {
            alert("請輸入正確的 Email！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 256) {
            alert(
              "此 Email 非展昭會員帳號，請通知該人員前往進行展昭會員註冊！"
            );
            $("#AddCardModal").modal("hide");
          }
        });
      }
    },

    EnAddStaffInfo() {
      const vm = this;
      const url = "/apiExhibitors/Boothstaff/";

      const info = {
        RegNo: vm.RegNo,
        Email: vm.staffMail,
        CSRF: vm.CSRF_Token,
        Lang: "en",
      };

      // console.log(info)

      if (!vm.staffMail) {
        alert("There are incomplete fields, please check again.");
      } else {
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("New e-business card added successfully！");
            $("#AddCardModal").modal("hide");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("System is busy, please try again later.");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 254) {
            alert(
              "This email account has been registered, please try another one！"
            );
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 253) {
            alert(
              "Failed to add new e-business card, it has exceeded the limit！"
            );
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 255) {
            alert(" This email account is incorrect！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 256) {
            alert(
              "This email account is not recognized by Chan Chao membership, please check your registration！"
            );
            $("#AddCardModal").modal("hide");
          }
        });
      }
    },

    TwEnAddStaffInfo() {
      const vm = this;
      const url = "/apiExhibitors/Boothstaff/";

      const info = {
        RegNo: vm.RegNo,
        Email: vm.staffMail,
        CSRF: vm.CSRF_Token,
        Lang: "en",
      };

      // console.log(info)

      if (!vm.staffMail) {
        alert("There are incomplete fields, please check again.");
      } else {
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("New e-business card added successfully！");
            $("#AddCardModal").modal("hide");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("System is busy, please try again later.");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 254) {
            alert(
              "This email account has been registered, please try another one！"
            );
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 253) {
            alert(
              "Failed to add new e-business card, it has exceeded the limit！"
            );
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 255) {
            alert(" This email account is incorrect！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 256) {
            alert(
              "This email account is not recognized by Chan Chao membership, please check your registration！"
            );
            $("#AddCardModal").modal("hide");
          }
        });
      }
    },

    EnCnAddStaffInfo() {
      const vm = this;
      const url = "/apiExhibitors/Boothstaff/";

      const info = {
        RegNo: vm.RegNo,
        Email: vm.staffMail,
        CSRF: vm.CSRF_Token,
        Lang: "en",
      };

      // console.log(info)

      if (!vm.staffMail) {
        alert("輸入欄位不完整，請重新檢查！");
      } else {
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("電子名片新增成功！");
            $("#AddCardModal").modal("hide");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_zhtw_onlineExpoCardInfo?no=${vm.RegNo}`;
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("系統忙碌，請稍後再試！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 254) {
            alert("您輸入的 Email 已被使用，請重新輸入！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 253) {
            alert("新增失敗，已超過電子名片額度上限！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 255) {
            alert(" 請輸入正確的 Email！");
            $("#AddCardModal").modal("hide");
          } else if (response.data.Code == 256) {
            alert(
              "此 Email 非展昭會員帳號，請通知該人員前往進行展昭會員註冊！"
            );
            $("#AddCardModal").modal("hide");
          }
        });
      }
    },
  },

  created() {
    const vm = this;

    //取得語系

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得攤位人員資料
    axios
      .get(
        `https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaff/${vm.RegNo}?group=`
      )
      .then((response) => {
        vm.CardInfo = response.data;
        vm.CardNum = response.data.length;

        if (!vm.CardNum) {
          vm.firstEntry = true;
        } else {
          vm.firstEntry = false;
        }
      });

    //取得vip資格
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        if (response.data.Data.Vip == 3) {
          vm.isVip = true;
        } else {
          vm.isVip = false;
        }
      });

    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    $(function () {
      $("#AddCardModal").on("hide.bs.modal", function () {
        vm.staffMail = "";
      });
    });

    $(function () {
      $("#EditCardModal").on("hide.bs.modal", function () {
        vm.staffMail = "";
      });
    });
  },
};
</script>

<style lang="scss">
.card {
  position: relative;
  /* width: 427px;
        height: 270px; */
  width: 427px;
  min-height: 260px;
  border-radius: 0.95rem;
  border: 0px;
}

a:hover {
  color: #066a99;
  text-decoration: none;
}

.card-body {
  padding: 0.5rem;
}

.card-header {
  padding: 0rem 0.8rem;
  margin-bottom: 0;
  background-color: #eecf8d;
  border-bottom: 0px;
  border-radius: 0.95rem 0.95rem 0.15rem 0.15rem;
}

.card-header:first-child {
  border-radius: calc(0.95rem - 1px) calc(0.95rem - 1px) 0 0;
}

.delIcon {
  position: absolute;
  top: -19px;
  left: 410px;
  font-size: 36px;
}

.delIcon:hover {
  filter: brightness(1.1);
}

.BannerHover:hover {
  filter: brightness(0.9);
}

@media screen and (max-width: 576px) {
  .card {
    position: relative;
    width: 280px;
    height: 325px;
    border-radius: 0.95rem;
    border: 0px;
  }

  .delIcon {
    position: absolute;
    top: -8px;
    left: 258px;
    font-size: 36px;
  }
}
</style>
